import {
  DeviceDetailsDto,
  DeviceDto,
  QsTrinityProDetailsDto,
  QsUavDetailsDto,
} from '../models/device.model';

export function getDeviceDisplayName(device?: DeviceDto): string {
  const details = device?.details;

  return (
    device?.nameAlias?.trim() ||
    device?.deviceSummary?.defaultName?.trim() ||
    device?.deviceId?.trim() ||
    (isAircraftDeviceDetails(details)
      ? details.aircraftModel?.name?.trim()
      : undefined) ||
    ''
  );
}

export function getDeviceUnitNumber(device?: DeviceDto): string {
  const details = device?.details;
  const detailsUnitId = isAircraftDeviceDetails(details)
    ? details.unitId
    : undefined;

  return (
    device?.deviceSummary?.unitId?.trim() ||
    (detailsUnitId !== undefined && detailsUnitId !== null
      ? String(detailsUnitId)
      : undefined) ||
    device?.deviceId?.trim() ||
    'device'
  );
}

export function getDeviceModelName(device?: DeviceDto): string {
  const details = device?.details;

  return (
    device?.deviceSummary?.model?.trim() ||
    device?.deviceSummary?.modelName?.trim() ||
    (isAircraftDeviceDetails(details)
      ? details.aircraftModel?.name?.trim()
      : undefined) ||
    details?.type ||
    device?.deviceType?.trim() ||
    ''
  );
}

function isAircraftDeviceDetails(
  details?: DeviceDetailsDto,
): details is QsUavDetailsDto | QsTrinityProDetailsDto {
  return details?.type === 'QsUav' || details?.type === 'QsTrinityPro';
}
